import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthenticationService } from '../_services/authentication.service';
import { UserInfoService } from '../_services/userInfo.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        readonly userInfoService: UserInfoService
    ) { }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    //     const currentUser = this.authenticationService.currentUserValue;
    //     if (currentUser) {
    //         // check if route is restricted by role
    //         if (route.data.roles && route.data.roles.indexOf(currentUser.role) === -1) {
    //             // role not authorised so redirect to home page
    //             this.router.navigate(['/dashboard/Map']);
    //             return false;
    //         }

    //         // authorised so return true
    //         return true;
    //     }

    //     // not logged in so redirect to login page with the return url
    //     this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    //     return false;
    // }

    userId: any;
    roleId:any;
    canActivate(
      next: ActivatedRouteSnapshot,
      state: RouterStateSnapshot){
        this.userId = this.userInfoService.userDetails;
        if(this.userId){
        return true;
        }
        this.router.navigate(['']);
      return false;
    }
}